var React = require('react');

import { GenericSimpleToggleButton, GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

const PopUpBloqueado = (props) => {
    return (
        <div className="dropdown state" id="state-block">
            <button type="button" data-toggle="dropdown" data-target="#state-block"
                className="btn btn-cta btn-sm btn-blocked">BLOQUEADO</button>
            <ul className="dropdown-menu">
                <li className="bottom-separator-xs">
                    {(!props.usuario.Bloqueado_Inactividad) && (<p>{"Bloqueado por " + props.usuario.BloqueadoPor + " el " + props.usuario.FechaBloqueo + " a las " + props.usuario.HoraBloqueo}</p>)}
                    <p className="state-break"><i>{props.usuario.Bloqueado_Inactividad ? 'Usuario bloqueado por inactividad' : props.usuario.MotivoBloqueo}</i></p>
                </li>
                <li className="state-bottom">
                    <div className="row">
                        {props.functions.Modificacion && <div className="col-xs-12 text-right">
                            <button className="btn btn-secondary" type="button" onClick={() => props.setUserState(props.usuario.Id, true, false)}>Desbloquear</button>
                        </div>}
                    </div>
                </li>
            </ul>
        </div>
    );
}

export default PopUpBloqueado;